export class ThingData{
  things: Array<any> = [];
  areaMapList: Map<string, Array<any>> = new Map<string, Array<any>>();
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/thing/thingData.ts